import React from 'react';
import { Hidden } from '@material-ui/core';
import { Link } from 'react-router-dom';
import GoLectureImage from '../../img/banner/go_lecture_pop_up.png';

/**
 * 내 강의실 바로가기 플로팅 배너 (PC 전용)
 * - 화면 우측에 position: fixed로 고정
 * - PC 해상도(md 이상)에서만 노출
 * - 로그인 상태: /mypage로 이동
 * - 비로그인 상태: /login으로 이동
 */
const FloatingMyClassBanner = () => {
  const loginToken = localStorage.getItem('token');

  return (
    <Hidden smDown>
      <div
        style={{
          position: 'fixed',
          top: '16%',
          right: '1%',
          zIndex: 1000,
        }}
      >
        <Link to={loginToken ? '/learning' : '/login'}>
          <img
            src={GoLectureImage}
            alt="내 강의실 바로가기"
            style={{
              width: '85%',
              display: 'block',
              transition: 'transform 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          />
        </Link>
      </div>
    </Hidden>
  );
};

export default FloatingMyClassBanner;
